import { FilterChip, useQueryParams } from '@marqvision/shared';
import { useLogger } from '~/hooks';
import { useTab } from '~/pages/DomainNames/@hooks/useTab';
import { FilterQueryParams } from '~/pages/DomainNames/@types';

export const SSLCertificateFilter = () => {
  const { currentTabGroup } = useTab();
  const { amplitudeLogging } = useLogger();

  const { params, setParams, removeParams } = useQueryParams<FilterQueryParams>();

  const isSelected = Boolean(params.ssl_cert_filter);

  const handleToggle = () => {
    amplitudeLogging('applied filter', {
      Type: 'ssl certificate',
      Channel: 'domain names',
      Page: currentTabGroup.replace(/-/g, ' '),
    });

    if (isSelected) {
      removeParams('ssl_cert_filter');
    } else {
      setParams({ ssl_cert_filter: true }, { replace: true });
    }
  };

  return <FilterChip type="toggle" label="SSL certificate" selected={isSelected} onClick={handleToggle} />;
};
